import { Component, Inject } from '@angular/core';
import { DataHelper } from '@app/helpers/data.helper';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@app/services/api.service';
import { UserHelper } from '@app/helpers/user.helper';
export interface IDialogData {
  barcode: string;
  type: string;
}
export interface ITerminalData {
  BranhAddress: string;
  CompAddress: string;
  ExtensionData: object;
  LogoUrl: string;
}

@Component({
  selector: 'app-terminalPeru',
  templateUrl: './terminalPeru-print.component.html',
  styleUrls: ['./terminalPeru-print.component.sass'],
})
export class TerminalPeruPrintComponent {
  elementType = 'svg';
  format = 'CODE128';
  lineColor = '#000000';
  width = 2;
  height = 70;
  displayValue = true;
  fontOptions = '';
  font = 'monospace';
  textAlign = 'center';
  textPosition = 'bottom';
  textMargin = 10;
  fontSize = 16;
  background = '#ffffff';
  margin = 5;
  marginTop = 5;
  marginBottom = 5;
  marginLeft = 5;
  marginRight = 5;
  slipId = '';
  slipInfo = [];
  terminalInfo: Array<ITerminalData> = [];
  constructor(
    public _UserHelper: UserHelper,
    private _ApiService: ApiService,
    public dialogRef: MatDialogRef<TerminalPeruPrintComponent>,

    public _DataHelper: DataHelper,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData
  ) {
    this.slipId = data.barcode.split(',').join('').trim();
    data.barcode = '500' + this.slipId;

    this.getSlipOneData();
  }

  getSlipOneData() {
    this._ApiService.getCouponDetailBySlipId(this.slipId.trim()).then(x => {
      if (x == undefined) return;
      if (x == '') return;
      this.slipInfo = x;

      this.getBranchAddress();
    });
  }
  // }

  getBranchAddress() {
    this._ApiService.getBranchAddress(this._UserHelper.customerUser.BranchId).then((result: Array<ITerminalData>) => {
      if (result && result.length > 0) {
        this.terminalInfo = result;
      }
      this.printTicket();
    });
  }
  printTicket() {
    setTimeout(() => {
      const printContents = document.getElementById('PrintSlip_Modal');
      let newWindow = window.open('', 'Print-Window');
      newWindow.document.write(printContents.outerHTML);
      newWindow.document.close();
      newWindow.focus();
      newWindow.onbeforeprint = function () {
        // Yazdırma işlemi başlamadan önce yapılacak işlemler
      };

      newWindow.onafterprint = function () {
        // Yazdırma işlemi tamamlandıktan sonra yapılacak işlemler
        newWindow.close();
      };

      newWindow.print();
      this.dialogRef.close();
    }, 500);
  }
}
